export enum CollapseStatus {
  collapsed = 'collapsed',
  open = 'open',
}
